import { RmmState, RmmStatus } from '../../interfaces/Rmm';

export function badgeTone(status: RmmStatus) {
  switch (status) {
    case 'online':
      return 'bg-emerald-50 text-emerald-800 dark:bg-emerald-900/20 dark:text-emerald-200';
    case 'offline':
      return 'bg-red-50 text-red-800 dark:bg-red-900/20 dark:text-red-200';
    case 'warning':
      return 'bg-amber-50 text-amber-800 dark:bg-amber-900/20 dark:text-amber-200';
    default:
      return 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200';
  }
}

export function borderTone(rmm?: RmmState) {
  if (!rmm) {
    return 'border-slate-200 dark:border-slate-700';
  }
  if (rmm.loading) {
    return 'border-slate-300 dark:border-slate-600';
  }
  if (!rmm.present) {
    return 'border-amber-400 dark:border-amber-600';
  }

  switch (rmm.status) {
    case 'online':
      return 'border-emerald-400 dark:border-emerald-600';

    case 'offline':
      return 'border-red-400 dark:border-red-600';

    case 'warning':
      return 'border-amber-400 dark:border-amber-600';

    case 'unknown':
    default:
      return 'border-slate-300 dark:border-slate-600';
  }
}
